import { render, staticRenderFns } from "./ListChain.vue?vue&type=template&id=2e75be56"
import script from "./ListChain.vue?vue&type=script&lang=js"
export * from "./ListChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports